import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
var index = (resolve) => { //首页
	import('@/components/index').then((module) => {
		resolve(module)
	})
}
// var index = (resolve) => { //首页
// 	import('@/components/products/UpdateTrade').then((module) => {
// 		resolve(module)
// 	})
// }
var customer = (resolve) => { //用户中心
	import('@/components/customer/customer').then((module) => {
		resolve(module)
	})
}
var login = (resolve) => { //登录页
	import('@/components/customer/login').then((module) => {
		resolve(module)
	})
}
var create = (resolve) => { //注册页
	import('@/components/customer/create').then((module) => {
		resolve(module)
	})
}
var psd = (resolve) => { //忘记密码
	import('@/components/customer/psd').then((module) => {
		resolve(module)
	})
}
var products = (resolve) => { //商品列表页
	import('@/components/products/products').then((module) => {
		resolve(module)
	})
}
var proDetail = (resolve) => { //商品详情页
	import('@/components/products/proDetail').then((module) => {
		resolve(module)
	})
}
var proCustom = (resolve) => { //商品定制页
	import('@/components/products/proCustom').then((module) => {
		resolve(module)
	})
}
var UpdateTrade = (resolve) => { //商品定制页
	import('@/components/products/UpdateTrade').then((module) => {
		resolve(module)
	})
}
var panelCustom = (resolve) => {//面板定制页
	import('@/components/products/panelCustom').then((module) =>{
		resolve(module)
	})
}
var helpCenter = (resolve) => { //帮助中心
	import('@/components/products/helpCenter').then((module) => {
		resolve(module)
	})
}
var takeEardrum = (resolve) => { //定制流程
	import('@/components/products/takeEardrum').then((module) => {
		resolve(module)
	})
}
var share = (resolve) => { //shejifenxing
	import('@/components/products/share').then((module) => {
		resolve(module)
	})
}
var cart = (resolve) => { //购物车
	import('@/components/cart/cart').then((module) => {
		resolve(module)
	})
}
var checkout = (resolve) => { //收货地址
	import('@/components/cart/checkout').then((module) => {
		resolve(module)
	})
}
var payment = (resolve) => { //付款
	import('@/components/cart/payment').then((module) => {
		resolve(module)
	})
}
var wxPay = (resolve) => { //微信付款（移动）
	import('@/components/pay/WXPaySend').then((module) => {
		resolve(module)
	})
}
var wxPayPC = (resolve) => { //微信付款（PC）
	import('@/components/pay/WXPayPc').then((module) => {
		resolve(module)
	})
}
var pay = (resolve) => { //支付宝付款
	import('@/components/pay/pay').then((module) => {
		resolve(module)
	})
}
var payOK = (resolve) => { //移动端支付成功
	import('@/components/pay/payOK').then((module) => {
		resolve(module)
	})
}
var paySuc = (resolve) => { //移动端支付成功
	import('@/components/pay/paySuc').then((module) => {
		resolve(module)
	})
}
var customDetail = (resolve) => { //定制详情页
	import('@/components/customUni/customUni').then((module) => {
		resolve(module)
	})
}
//var test = (resolve) => { //测试
//	import('@/components/pay/test').then((module) => {
//		resolve(module)
//	})
//}
//var tests = (resolve) => { //测试
//	import('@/components/pay/tests').then((module) => {
//		resolve(module)
//	})
//}

export default new Router({
	mode: 'history',
	routes: [{
			path: '/',
			component: index,
			//redirect: '/index'
			//			meta: {
			//				keepAlive: false
			//			},
		},
		{
			path: '/index',
			component: index,
			//			children: [
			//				{
			//					path: '/products',
			//					name: 'products',
			//					component: products,
			//				},
			//			]
		},
		{
			path:'/Default/Index',
			redirect:"/",
		},
		{
			path: '/products',
			name: 'products',
			component: products,
		},

		{
			path: '/customer',
			name: 'customer',
			component: customer,
		},
		{
			path: '/customer/login',
			name: 'login',
			component: login,
		},
		{
			path: '/customer/create',
			name: 'create',
			component: create,
		},
		{
			path: '/customer/psd',
			name: 'psd',
			component: psd,
		},
		{
			path: '/products/proDetail',
			name: 'proDetail',
			component: proDetail,
			meta: { title: '' },
		},
		{
			path: '/products/proCustom',
			name: 'proCustom',
			component: proCustom,
			
		},
		{
			path: '/products/UpdateTrade',
			name: 'UpdateTrade',
			component: UpdateTrade,
			
		},
		{
			path: '/products/helpCenter',
			name: 'helpCenter',
			component: helpCenter,
		},
		{
			path: '/products/takeEardrum',
			name: 'takeEardrum',
			component: takeEardrum,
		},
		{
			path: '/products/share',
			name: 'share',
			component: share,
		},
		{
			path:'/products/panelCustom',
			name:'panelcustom',
			component:panelCustom,
		},		
		{
			path: '/cart',
			name: 'cart',
			component: cart,
		},
		{
			path: '/cart/checkout',
			name: 'checkout',
			component: checkout,
		},
		{
			path: '/cart/payment',
			name: 'payment',
			component: payment,
		},

		{
			path: '/pay/WXPayPc',
			name: 'WXPayPc',
			component: wxPayPC,
		},
		{
			path: '/pay/pay',
			name: 'pay',
			component: pay,
		},
		{
			path: '/pay/payOK',
			name: 'payOK',
			component: payOK,
		},
		{
			path: '/pay/WXPaySend',
			name: 'wxPay',
			component: wxPay,
		},
		{
			path: '/pay/paySuc',
			name: 'paySuc',
			component: paySuc,
		},
    {
			path: '/customDetail',
			name: 'customDetail',
			component: customDetail,
		},
		{
      path: "*",
      redirect: "/"
}

//		{
//			path: '/pay/test',
//			name: 'test',
//			component: test,
//		},
//		{
//			path: '/pay/tests',
//			name: 'tests',
//			component: tests,
//		},
	],
})


// WEBPACK FOOTER //
// ./src/router/index.js